// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9cf7feb3","304":"621060c0","726":"2efc1f8a","743":"b465eda4","766":"2f0de50f","822":"d22d122e"}[chunkId] + ".chunk.js";
};